import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import getStyled from "../../hooks/getStyled";
import "@splidejs/react-splide/css";
import "@splidejs/react-splide/css/core";

const { styled } = getStyled();

const SFSplideContainerStyled = styled("div")(({ theme }) => ({

  "& .splide__pagination": {
    bottom: -20,
    "& .splide__pagination__page": {
      opacity: 1,
      backgroundColor: "#747480",
      borderRadius: 4,
      height: 6,
      width: 20,
      margin: 4,
      "&.is-active": {
        backgroundColor: "#188CE5",
        transform: "scale(1.1)",
      },
    },
  },

}));

// Splide slide container with custom navigation arrows
const SFCarouselContainer = ({ children, options }) => {
  return (
    <SFSplideContainerStyled>
      <Splide options={options}>
        {Array.isArray(children) &&
          children.map((item, index) => (
            <SplideSlide key={index}>{item}</SplideSlide>
          ))}
      </Splide>
    </SFSplideContainerStyled>
  );
};

export default SFCarouselContainer;
